import React from 'react';
import { VirtualizedWcTable } from '@/components/VirtualizedWcTable';
import { Upload, RotateCcw, Search } from 'lucide-react';

export function AdminWcRatesCard({
  STATES,
  wcRateTable,
  setWcRateTable,
  wcUploadInfo,
  wcFileRef,
  handleWcUpload,
  wcFilter,
  setWcFilter,
  filteredWcRates,
  wcIsCustom,
  flattenWcRates,
  DEFAULT_WC_RATES,
  WC_DESCRIPTIONS,
  WC_RISK_LABELS,
}) {
  const handleReset = () => {
    setWcRateTable(flattenWcRates(DEFAULT_WC_RATES, WC_DESCRIPTIONS, WC_RISK_LABELS));
    wcIsCustom.current = false;
  };

  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm" data-testid="wc-rates-card">
      <div className="p-5 border-b border-slate-100 flex items-center justify-between">
        <h2 className="text-base font-semibold font-['Outfit'] text-slate-900">
          WC Rate Table ({wcRateTable.length.toLocaleString()} entries)
        </h2>
        <div className="flex items-center gap-2">
          {wcUploadInfo && (
            <span className="text-xs text-emerald-600 font-medium" data-testid="wc-upload-info">
              {wcUploadInfo}
            </span>
          )}
          <input
            ref={wcFileRef}
            type="file"
            accept=".csv,.xlsx,.xls"
            onChange={handleWcUpload}
            className="hidden"
          />
          <button
            data-testid="upload-wc-rates-btn"
            onClick={() => wcFileRef.current?.click()}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-[#3c68ff] text-white rounded-lg text-xs font-medium hover:bg-[#2b4bca] transition-all"
          >
            <Upload size={13} /> Upload CSV/Excel
          </button>
          {wcIsCustom.current && (
            <button
              data-testid="reset-wc-rates-btn"
              onClick={handleReset}
              className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-slate-200 text-slate-600 rounded-lg text-xs font-medium hover:bg-slate-50 transition-all"
            >
              <RotateCcw size={13} /> Reset
            </button>
          )}
        </div>
      </div>
      <div className="p-4 border-b border-slate-100 flex items-center gap-3 bg-slate-50/50">
        <Search size={14} className="text-slate-400" />
        <select
          data-testid="wc-filter-state"
          value={wcFilter.state}
          onChange={e => setWcFilter(prev => ({ ...prev, state: e.target.value }))}
          className="h-8 rounded-lg border border-slate-200 bg-white px-2 text-xs focus:outline-none focus:ring-2 focus:ring-[#3c68ff]"
        >
          <option value="">All States</option>
          {STATES.map(s => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
        <input
          data-testid="wc-filter-code"
          value={wcFilter.code}
          onChange={e => setWcFilter(prev => ({ ...prev, code: e.target.value }))}
          placeholder="Filter by code..."
          className="h-8 rounded-lg border border-slate-200 bg-white px-3 text-xs focus:outline-none focus:ring-2 focus:ring-[#3c68ff] w-40"
        />
        <span className="text-xs text-slate-500">
          Showing {filteredWcRates.length} of {wcRateTable.length.toLocaleString()}
        </span>
      </div>
      <VirtualizedWcTable data={filteredWcRates} totalCount={wcRateTable.length} />
    </div>
  );
}
